import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import OnboardingUpdatesMessages from './OnboardingUpdatesMessages';
import FestiveUpdatesMessages from './FestiveUpdatesMessages';
import BabyMilestoneMemoryMessages from './BabyMilestoneMemoryMessages';
import PaymentUpdatesMessages from './PaymentUpdatesMessages';
import NewYellowUserUpdates from './NewYellowUserUpdates';
import TodoListUpdates from './TodoListUpdates';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} >
          <Tab label="Baby Milestone & Memory" {...a11yProps(0)} style={{textTransform:"none"}}/>
          <Tab label="Festive Updates" {...a11yProps(1)} style={{textTransform:"none"}}/>
          <Tab label="Onboarding Updates" {...a11yProps(2)} style={{textTransform:"none"}}/>
          <Tab label="Payment Updates" {...a11yProps(3)} style={{textTransform:"none"}}/>
          <Tab label="New/Yellow Users Updates" {...a11yProps(4)} style={{textTransform:"none"}}/>
          <Tab label="Todo List" {...a11yProps(5)} style={{textTransform:"none"}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
       <BabyMilestoneMemoryMessages />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <FestiveUpdatesMessages />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <OnboardingUpdatesMessages />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <PaymentUpdatesMessages />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <NewYellowUserUpdates />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <TodoListUpdates />
      </CustomTabPanel>
    </Box>
  );
}